/**
 * Client-to-server Socket.IO message names accepted by the records gateway.
 */
export enum ClientWebsocketMessageEnum {
  /** Subscribe to list opinions for a subject and filter set. */
  LIST_SUBSCRIBE = 'list_subscribe',
  /** Tear down a prior list subscription. */
  LIST_UNSUBSCRIBE = 'list_unsubscribe',
}
